const dorfentwicklungenJson = require.context("../cms/dorfentwicklungen", false, /\.json$/);

const BLOB_ASSETS_URL = "https://dorfentwicklungfiles.blob.core.windows.net/assets";

const toAssetUrl = (path: string): string =>
	path
		.replace("/public/dorfentwicklungen/protokolle", `${BLOB_ASSETS_URL}/dorfentwicklungen/protokolle`)
		.replace("/public/dorfentwicklungen/plaene", `${BLOB_ASSETS_URL}/dorfentwicklungen/plaene`)
		.replace("/public", "");

export type Dorfentwicklung = {
	name: string;
	text: string;
	creationDate?: Date;
	dorfentwicklungsplan?: string;
	coverImage: string;
	order: number;
	headerImage?: string;
	protocols: {
		name: string;
		date: Date;
		pdf: string;
	}[];
};

export const loadAllDorfentwicklungen = (): Dorfentwicklung[] => {
	return dorfentwicklungenJson
		.keys()
		.map((key) => {
			const fileName = key.replace("./", "");
			const resource = require(`../cms/dorfentwicklungen/${fileName}`);
			return parseDorfentwicklungFromFile(JSON.stringify(resource));
		})
		.sort((a, b) => b.order - a.order);
};

export const parseDorfentwicklungFromFile = (jsonString: string): Dorfentwicklung => {
	const plainParseResult = JSON.parse(jsonString);

	const dorfentwicklungsplan = plainParseResult?.dorfentwicklungsplan
		? toAssetUrl(plainParseResult.dorfentwicklungsplan)
		: undefined;

	const headerImage = plainParseResult?.headerImage ? toAssetUrl(plainParseResult.headerImage) : undefined;

	const creationDate =
		plainParseResult?.creationDate && plainParseResult?.creationDate !== ""
			? new Date(plainParseResult.creationDate)
			: undefined;

	return {
		...plainParseResult,
		coverImage: toAssetUrl(plainParseResult.coverImage),
		headerImage,
		dorfentwicklungsplan,
		creationDate,
		protocols:
			plainParseResult.protocols?.map((protocol: { name: string; date: string; pdf: string }) => ({
				...protocol,
				pdf: toAssetUrl(protocol.pdf),
				date: new Date(protocol.date),
			})) || [],
	};
};
